<template>
    <aside
            class="cancel-subscription-modal"
    >
        <FullBackdrop>
            <div
                    class="dialog loadable failable"
                    :class="dialogClasses"
            >
                <!-- Step 1: Solicitamos confirmacion -->
                <template v-if="currentStep === 'alert'">
                    <div>
                        <div class="icon">⚠</div>
                        <h4>{{$t('unsubscribe.title')}}</h4>
                        <p>{{$t('unsubscribe.warning')}}</p>
                    </div>
                    <div class="footer">
                        <button
                                class="btn-main"
                                type="button"
                                @click="cancelSubscription"
                        >
                            {{$t('unsubscribe.buttons.unsubscribe')}}
                        </button>
                        <button
                                class="btn-main"
                                type="button"
                                @click="cancelHandler"
                        >
                            {{$t('cancel')}}
                        </button>
                    </div>
                </template>
                <!-- Step 1: Solicitamos confirmacion -->

                <!-- Step 2: Ofrecemos promos -->
                <template v-else-if="currentStep === 'promos'">
                    <div>
                        <div class="icon">⚠</div>
                        <h4>{{$t('unsubscribe.title')}}</h4>
                        <p>{{$t('unsubscribe.promos.subtitle')}}</p>
                        <div v-if="additionalMembershipOffers.data">
                            <div
                                    class="offer"
                                    v-for="offer in additionalMembershipOffers.data"
                                    @click="applyAdditionalMembershipOffer(offer)"
                            >
                                <p>
                                    {{
                                        $t(offer.is_trial ? 'unsubscribe.promos.offers.trial' : 'unsubscribe.promos.offers.extend', {
                                            period: `${offer.extra_days} ${$tc(`subscription.periods.days`, offer.extra_days)}`
                                        })
                                    }}
                                </p>
                                <button type="button">
                                    Aprovechar
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="footer">
                        <button
                                :disabled="additionalMembershipOffers.loading || additionalMembershipOffers.error || additionalMembershipOffers.timer > 0"
                                class="btn-main btn-reject"
                                type="button"
                                @click="nextStep"
                        >
                            {{$t('unsubscribe.buttons.reject_offer')}}
                            <span class="timer" v-show="additionalMembershipOffers.timer > 0">
                                ({{additionalMembershipOffers.timer}})
                            </span>
                        </button>
                        <!--<button
                                class="btn-main"
                                type="button"
                                @click="cancelHandler"
                        >
                            {{$t('cancel')}}
                        </button>-->
                    </div>
                </template>
                <!-- Step 2: Ofrecemos promos -->

                <!-- Step 3: Formulario de desuscripcion -->
                <template v-else-if="currentStep === 'form'">
                    <div>
                        <div class="icon">⚠</div>
                        <h4>{{$t('unsubscribe.title')}}</h4>
                        <p>
                            <template v-if="unsubscriptionRequest.loading || unsubscriptionRequest.error">
                                {{$t('unsubscribe.request.loading')}}
                            </template>
                            <template v-else>
                                {{$t('unsubscribe.request.sent')}}
                            </template>
                        </p>
                    </div>
                    <div class="middle">
                        <div class="group">
                            <input type="text" v-model="deletingSubscription.form.code"/>
                            <button
                                    class="btn-main"
                                    type="button"
                                    @click="cancelSubscription"
                            >
                                {{$t('unsubscribe.buttons.unsubscribe')}}
                            </button>
                        </div>
                        <p class="invalid" v-if="deletingSubscription.invalid">
                            {{$t('unsubscribe.invalid')}}
                        </p>
                        <p class="invalid" v-if="deletingSubscription.error">
                            {{$t('unsubscribe.error')}}
                        </p>
                    </div>
                    <div class="footer">
                        <button
                                class="btn-main"
                                type="button"
                                @click="cancelHandler"
                        >
                            {{$t('cancel')}}
                        </button>
                    </div>
                </template>
                <!-- Step 3: Formulario de desuscripcion -->

                <!-- Step 4: Mensaje de aviso -->
                <template v-else-if="currentStep === 'done'">
                    <div>
                        <div class="icon">⚠</div>
                        <h4>{{$t('unsubscribe.done.title')}}</h4>
                        <p>
                            {{$t('unsubscribe.done.subtitle')}}
                        </p>
                    </div>
                    <div class="footer">
                        <button
                                class="btn-main"
                                type="button"
                                @click="subscriptionUpdatedHandler"
                        >
                            {{$t('accept')}}
                        </button>
                    </div>
                </template>
                <!-- Step 4: Mensaje de aviso -->

                <div class="loader-wrapper">
                    <div>
                        <Spinner/>
                    </div>
                </div>
                <div class="failed-wrapper">
                    <div>
                        <p>
                            {{$t('error')}}
                        </p>
                        <button
                                type="button"
                                @click.prevent="retryHandler"
                        >
                            {{$t('retry')}}
                        </button>
                        <button
                                type="button"
                                @click="cancelHandler"
                        >
                            {{$t('cancel')}}
                        </button>
                    </div>
                </div>
            </div>
        </FullBackdrop>
    </aside>
</template>
<script>
    import FullBackdrop from "./FullBackdrop"
    import Spinner from "./Spinner"
    import resources from "../resources";

    let timerInterval;

    export default {
        components: {FullBackdrop, Spinner},
        props: {
            subscription: {
                required: true,
                type: Object,
            }
        },
        data(){
            return {
                currentStep: 'alert',
                additionalMembershipOffers: {
                    timer: 0,
                    data: null,
                    error: false,
                    loading: false,
                },
                unsubscriptionRequest: {
                    data: null,
                    error: false,
                    loading: false,
                },
                deletingSubscription: {
                    data: null,
                    loading: false,
                    error: false,
                    form: {
                        code: '',
                    },
                    invalid: false,
                },
                done: false,
            }
        },
        methods: {
            nextStep(){
                switch(this.currentStep){
                    case 'alert': return this.currentStep = 'done';
                    // case 'alert': return this.currentStep = 'promos';
                    // case 'promos': return this.currentStep = 'form';
                    // case 'form': return this.currentStep = 'done';
                }
            },
            cancelHandler(){
                this.$emit('cancel');
            },
            subscriptionUpdatedHandler(){
                this.$emit('updated');
            },
            retryHandler(){
                this.load();
            },
            updateLoggedUser(){
                this.$auth.fetch({params: {}, success(){}, error(){}});
            },
            loadAdditionalMembershipOffers(){
                this.additionalMembershipOffers.loading = true;
                this.additionalMembershipOffers.error = false;
                this.additionalMembershipOffers.data = null;

                resources.additionalMembershipOffers.index({})
                    .then((resp) => {
                        this.additionalMembershipOffers.data = resp.data.data;
                        this.additionalMembershipOffers.loading = false;
                        this.additionalMembershipOffers.error = false;

                        if(this.additionalMembershipOffers.data.length === 0){
                            this.nextStep();
                        }else{
                            this.additionalMembershipOffers.timer = 10;
                        }
                    })
                    .catch(() => {
                        this.additionalMembershipOffers.loading = false;
                        this.additionalMembershipOffers.error = true;
                    });
            },
            applyAdditionalMembershipOffer(offer){
                this.additionalMembershipOffers.loading = true;

                resources.additionalMembershipOffers.update({id: offer.id, accepted: true})
                    .then(() => {
                        this.additionalMembershipOffers.loading = false;

                        this.updateLoggedUser();
                        this.subscriptionUpdatedHandler();
                        this.currentStep = 'done';
                    })
                    .catch(() => {
                        this.additionalMembershipOffers.loading = false;
                        this.additionalMembershipOffers.error = true;
                    });
            },
            loadRequestUnsubscription(){
                this.unsubscriptionRequest.error = false;
                this.unsubscriptionRequest.loading = true;

                resources.unsubscriptionRequests.store({subscription_id: this.subscription.id})
                    .then(() => {
                        this.unsubscriptionRequest.loading = false;
                    })
                    .catch(() => {
                        this.unsubscriptionRequest.error = true;
                        this.unsubscriptionRequest.loading = false;
                    });
            },
            cancelSubscription(){
                this.deletingSubscription.error = false;
                this.deletingSubscription.loading = true;
                this.deletingSubscription.invalid = false;

                resources.subscriptions.delete({id: this.subscription.id, code: this.deletingSubscription.form.code})
                    .then((response) => {
                        this.updateLoggedUser();
                        this.subscriptionUpdatedHandler();
                        this.nextStep();
                    })
                    .catch((err) => {
                        this.deletingSubscription.loading = false;

                        if(err.status === 403){
                            this.deletingSubscription.invalid = true;
                        }else{
                            this.deletingSubscription.error = true;
                        }
                    });
            },
            load(){
                switch(this.currentStep){
                    case 'promos':
                        this.loadAdditionalMembershipOffers();
                        break;
                    case 'form':
                        this.loadRequestUnsubscription();
                        break;
                }
            }
        },
        watch: {
            currentStep: {
                handler() {
                    this.load();
                },
                immediate: true,
            }
        },
        computed: {
            dialogClasses(){
                return {
                    loading: this.additionalMembershipOffers.loading || this.unsubscriptionRequest.loading || this.deletingSubscription.loading,
                    failed: this.additionalMembershipOffers.error || this.unsubscriptionRequest.error || this.deletingSubscription.error,
                };
            },
        },
        created() {
            timerInterval = setInterval(() => {
                if(this.additionalMembershipOffers.timer > 0){
                    this.additionalMembershipOffers.timer--;
                }
            }, 1000);
        },
        beforeDestroy() {
            clearInterval(timerInterval);
        }
    }
</script>

<style lang="scss" scoped>
    @import '../styles/variables';
    @import '../styles/classes';

    .cancel-subscription-modal{
        .dialog{

            .icon{
                font-size: 150px;
                color: $pallete_main_color;
            }

            color: $pallete_dark_text_color;
            text-align: center;
            padding: 1.5em;
            width: 100%;
            max-width: 500px;
            height: 100%;
            background-color: whitesmoke;

            &.failed{
                .failed-wrapper{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    width: 100%;
                    height: 100%;

                    & > div{
                        display: block;
                        background-color: #ffffff;
                        border-radius: 1em;
                        padding: 1em;
                    }

                    button{
                        margin: .5em;
                    }
                }
            }
        }

        .middle .group{
            display: flex;
            flex-direction: row;

            border: 2px solid $pallete_main_color;

            input{
                padding-left: .5em;
                border: none;
                flex: 1;
            }
        }

        .footer{
            margin-top: 1em;
            text-align: center;

            button {
                margin-left: 1em;
                margin-right: 1em;
            }
        }

        .offer{
            background-color: $pallete_main_color;
            padding: 1em;
            cursor: pointer;
            border-radius: 5px;
            margin: 15px 0;

            p{
                font-weight: bold;
                color: $pallete_clear_text_color;
            }

            button{
                @extend %fresh-btn;
            }
        }

        .btn-reject{

        }
    }
</style>